import { useState } from 'react';
import '../styles/modal.css';

let resolverActual = null;
let actualizarEstado = null;

export function confirmar(mensaje, opciones = {}) {
  const { variante = 'normal', textoAceptar = 'Aceptar', textoCancelar = 'Cancelar' } = opciones;
  return new Promise((resolve) => {
    resolverActual = resolve;
    actualizarEstado({ abierto: true, mensaje, variante, textoAceptar, textoCancelar });
  });
}

const ESTADO_INICIAL = { abierto: false, mensaje: '', variante: 'normal', textoAceptar: 'Aceptar', textoCancelar: 'Cancelar' };

const ConfirmModal = () => {
  const [estado, setEstado] = useState(ESTADO_INICIAL);
  actualizarEstado = setEstado;

  const responder = (resultado) => {
    setEstado(ESTADO_INICIAL);
    if (resolverActual) {
      resolverActual(resultado);
      resolverActual = null;
    }
  };

  if (!estado.abierto) return null;

  const claseAceptar = estado.variante === 'peligro' ? 'btn-danger' : 'btn-success';

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <p>{estado.mensaje}</p>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={() => responder(false)}>{estado.textoCancelar}</button>
          <button className={claseAceptar} onClick={() => responder(true)}>{estado.textoAceptar}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
